import { createApp } from "vue";
import App from "./App.vue";
import { createRouter, createWebHistory } from "vue-router";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery";
import "popper.js";
import "@/assets/css/main.css";
import $ from 'jquery';
window.$ = $;

// ページ（コンポーネント）をインポート
// import TopPage from "./views/TopPage.vue";
import OrderPage from "./views/OrderPage.vue";
import OrderForm from "./views/OrderForm.vue";
import ShoporderForm from "./views/ShoporderForm.vue";
import ContactForm from "./views/ContactForm.vue";
import ConfirmationPage from "./views/Confirmation.vue";
import ThanksPage from "./views/ThanksPage.vue";
import TestLinks from "./views/TestLinks.vue";
import InquiryConfirmation from "./views/InquiryConfirmation.vue";
import ContactThanksPage from "./views/ContactThanksPage.vue";
import PrivacyPolicy from "./views/PrivacyPolicy.vue";
import TermsOfService from "./views/TermsOfService.vue";
import SpecifiedCommercialTransactions from "./views/SpecifiedCommercialTransactions.vue";

// ルート（URLとページの対応）を設定
const routes = [
  // { path: "/", name: "TopPage", component: TopPage },
  { path: "/", redirect: "/order" },
  { path: "/order", name: "OrderPage", component: OrderPage },
  { path: "/order-form", name: "OrderForm", component: OrderForm },
  { path: "/shop-order-form", name: "ShopOrderForm", component: ShoporderForm },
  { path: "/contact", name: "ContactForm", component: ContactForm },
  {
    path: "/confirmationPage",
    name: "ConfirmationPage",
    component: ConfirmationPage,
    props: (route) => ({ formData: route.params.formData }), // propsとしてparamsを渡す
  },
  { path: "/thanks-page", name: "ThanksPage", component: ThanksPage },
  { path: "/test-links", name: "TestLinks", component: TestLinks },
  { path: "/inquiry-confirmation", name: "InquiryConfirmation", component: InquiryConfirmation },
  { path: "/contact-thanks-page", name: "ContactThanksPage", component: ContactThanksPage },
  { path: "/privacy-policy", name: "PrivacyPolicy", component: PrivacyPolicy },
  { path: "/terms-of-service", name: "TermsOfService", component: TermsOfService },
  {
    path: "/specified-commercial-transactions",
    name: "SpecifiedCommercialTransactions",
    component: SpecifiedCommercialTransactions,
  },
];

// Routerを作成
const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  },
});

// router.beforeEach((to, from, next) => {
//   // 遷移先が ConfirmationPage の場合、遷移元情報を query に追加
//   if (to.name === "ConfirmationPage" && from.name === "ShopOrderForm") {
//     to.query.fromShopOrder = true; // 遷移元が ShopOrderForm であることを設定
//   }
//   next(); // 次の処理へ進む
// });

// アプリケーションを作成し、Routerを適用してマウント
const app = createApp(App);
app.use(router); // Routerを使用
app.mount("#app");
